module.exports = __webpack_public_path__ + "static/img/bonus_6.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_6.png
// module id = kF0H
// module chunks = 0